import { createContext } from "react";

const UserAuth = createContext()

export default UserAuth;